import api from '@/client/core/api'
import { PutCampaignMemoResponse } from '@/typings/campaigns'

import { CampaignMemoApiError } from './campaignMemoApiError'

export async function putCampaignMemo(campaignId: number, memo: string): Promise<true> {
  const response = await api.put<PutCampaignMemoResponse>(`/campaigns/${campaignId}/memo`, { memo })

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new CampaignMemoApiError(response.error.type, response.error.message, response.error.status)
  }

  if (response?.data !== true) {
    throw new CampaignMemoApiError('INVALID_RESPONSE', 'キャンペーンメモ保存APIのレスポンス形式が不正です。')
  }

  return true
}
